module.exports = __webpack_public_path__ + "4d2f26bd3d4063a1c5359d6deedc8d79.pdf";